import { Injectable } from "@angular/core";
import { CTDatatablePaginationParameter } from "@ctsolution/ct-framework";

@Injectable()
export class ListService {

  constructor() {
  }

  getFilteredData<T>(list: Array<T>, params: any = {}, pagination?: CTDatatablePaginationParameter) {

    const pageIndex = pagination?.Page ? pagination.Page - 1 : 0;
    const pageSize = pagination?.ElementsForPage || 10;

    const startIndex = pageIndex * pageSize;
    const endIndex = startIndex + pageSize;

    const filteredData = list
      .filter(current => {

        for (const key in params) {

          const paramValue = (<any>params)[key]?.toLowerCase();
          const userValue = (<any>current)[key]?.toLowerCase();

          if (paramValue && !userValue) return false;

          if (paramValue && userValue && !userValue.includes(paramValue)) return false;

        }

        return true;

      });

    return filteredData.slice(startIndex, endIndex);

  }


  getFilteredDataAddressBook<T>(list: Array<T>, params: any = {}, pagination?: CTDatatablePaginationParameter) {

    const pageIndex = pagination?.Page ? pagination.Page - 1 : 0;
    const pageSize = pagination?.ElementsForPage || 10;

    const startIndex = pageIndex * pageSize;
    const endIndex = startIndex + pageSize;

    const filteredData = list.filter(current => {
      for (const key in params) {
        const paramValueRaw = (<any>params)[key];
        const currentValueRaw = (<any>current)[key];
    
        if (paramValueRaw == null) continue;
    
        // Se entrambi sono stringhe, confronta in lowercase
        if (typeof paramValueRaw === 'string' && typeof currentValueRaw === 'string') {
          const paramValue = paramValueRaw.toLowerCase();
          const userValue = currentValueRaw.toLowerCase();
    
          if (!userValue.includes(paramValue)) return false;
        }
        // Altrimenti confronta con uguaglianza stretta
        else if (paramValueRaw !== currentValueRaw) {
          return false;
        }
      }
    
      return true;
    });

    return filteredData.slice(startIndex, endIndex);

  }
}
